import { tryCatchFactory } from "./factory";
import type { ErrorContext, TryCatchContext } from "./types";
import { HonoErrorUtility } from "./utility";

export { HonoErrorUtility };

declare module "hono" {
	interface ContextVariableMap {
		tryCatch: TryCatchContext;
	}
}

export const tryCatch = tryCatchFactory({
	createContext: (options) => ({
		instance: new HonoErrorUtility(
			options.projectName,
			options.apiKey,
			options.debug,
		),
	}),
	handler: ({ instance }) => {
		return async (ctx, next) => {
			let errorContext: ErrorContext = {};

			ctx.set("tryCatch", {
				addContext: (errCtx: ErrorContext) => {
					errorContext = {
						...errorContext,
						...errCtx,
					};
				},
			} satisfies TryCatchContext);

			await next();

			if (ctx.error) {
				const error = ctx.error;
				if (error instanceof Error) {
					const ctrName = error.constructor.name;

                    // Do not use HTTPException class itself, Hono is only a peer dependency of tcc
					if (ctrName === "HTTPException") {
						return;
					}
				}

				instance
					.sendErrorFromEndPoint(ctx.error, ctx.req, errorContext)
					.then(() => {
						// console.log('error sent');
					})
					.catch((e) => {
						// console.error('error', e);
					});
			}
		};
	},
});
